// extracted by mini-css-extract-plugin
module.exports = {"back-to-top":"styles_back-to-top__VI_GP","is-active":"styles_is-active__IlDqL"};